import React, { useState, useEffect } from "react";
import qs from "query-string";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { getBackendUrl } from "../../config";
import wallfundo from "../../assets/f002.png";

/* ── mesmos estilos do Login ── */
const AUTH_CSS = `
  * { box-sizing: border-box; }
  .auth-page {
    min-height: 100vh; display: flex; align-items: center; justify-content: center;
    background: var(--auth-page-bg, #0d1117); padding: 24px;
  }
  .auth-root {
    display: flex; width: 100%; max-width: 1040px;
    border-radius: 20px; overflow: hidden;
    box-shadow: 0 32px 80px rgba(0,0,0,0.55);
    min-height: 560px;
  }
  /* ── painel esquerdo (slideshow) ── */
  .auth-left {
    position: relative; flex: 0 0 45%; overflow: hidden;
    display: none;
  }
  @media (min-width: 768px) { .auth-left { display: block; } }
  .auth-left__img {
    position: absolute; inset: 0; width: 100%; height: 100%;
    object-fit: cover; transition: opacity 1s ease-in-out;
  }
  .auth-left__overlay {
    position: absolute; inset: 0;
    background: linear-gradient(to bottom, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.72) 100%);
  }
  .auth-left__content {
    position: absolute; inset: 0; display: flex; flex-direction: column;
    padding: 36px 32px;
  }
  .auth-left__badge {
    display: inline-block; align-self: flex-start;
    background: rgba(255,255,255,0.18); backdrop-filter: blur(8px);
    color: #fff; font-size: 12px; font-weight: 600; letter-spacing: .06em;
    text-transform: uppercase; padding: 5px 14px; border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.25);
  }
  .auth-left__spacer { flex: 1; }
  .auth-left__title {
    color: #fff; font-size: 1.6rem; font-weight: 800;
    line-height: 1.25; margin: 0 0 10px; text-shadow: 0 2px 12px rgba(0,0,0,0.4);
  }
  .auth-left__desc {
    color: rgba(255,255,255,0.82); font-size: 0.95rem;
    line-height: 1.55; margin: 0 0 20px;
  }
  .auth-left__dots { display: flex; gap: 7px; }
  .auth-left__dot {
    width: 8px; height: 8px; border-radius: 999px;
    background: rgba(255,255,255,0.35);
    transition: background .3s, width .3s;
    border: none; cursor: pointer; padding: 0;
  }
  .auth-left__dot--active { background: #fff; width: 22px; }

  /* ── painel direito (formulário) ── */
  .auth-right {
    flex: 1; background: var(--auth-right-bg, #111827);
    display: flex; flex-direction: column; align-items: center;
    justify-content: center; padding: 48px 40px;
  }
  @media (max-width: 520px) { .auth-right { padding: 32px 20px; } }
  .auth-name {
    font-size: 1.25rem; font-weight: 800; letter-spacing: .05em;
    text-transform: uppercase; color: var(--auth-name, #fff);
    margin-bottom: 36px;
  }
  .auth-form-box { width: 100%; max-width: 360px; }
  .auth-heading {
    color: var(--auth-title, #fff); font-size: 1.6rem; font-weight: 700;
    margin: 0 0 6px;
  }
  .auth-subtext {
    color: var(--auth-subtitle, #9ca3af); font-size: 0.92rem;
    margin: 0 0 28px; line-height: 1.5;
  }
  .auth-form { width: 100%; }
  .auth-label {
    display: block; color: var(--auth-label, #d1d5db);
    font-size: 13px; font-weight: 500; margin-bottom: 6px;
  }
  .auth-field-wrap { position: relative; margin-bottom: 16px; }
  .auth-field {
    width: 100%; padding: 13px 16px;
    background: var(--auth-input-bg, rgba(255,255,255,0.06));
    border: 1px solid var(--auth-input-border, rgba(255,255,255,0.11));
    border-radius: 10px; color: var(--auth-input-text, #fff);
    font-size: 15px; font-family: inherit; outline: none;
    transition: border-color 0.2s, background 0.2s;
  }
  .auth-field:focus { border-color: var(--auth-primary, #6366f1); }
  .auth-field::placeholder { color: #6b7280; }
  .auth-field--pw { padding-right: 44px; }
  .auth-field-error {
    color: #f87171; font-size: 12px; margin-top: 4px;
  }
  .auth-pw-toggle {
    position: absolute; right: 12px; top: 50%; transform: translateY(-50%);
    background: none; border: none; cursor: pointer; color: #9ca3af;
    display: flex; align-items: center;
  }
  .auth-btn {
    width: 100%; padding: 14px; border: none; border-radius: 10px;
    background: var(--auth-primary, #6366f1);
    color: var(--auth-btn-text, #fff);
    font-size: 15px; font-weight: 700; cursor: pointer;
    transition: opacity .2s, transform .2s;
    margin-top: 8px;
  }
  .auth-btn:hover { opacity: 0.88; transform: translateY(-1px); }
  .auth-btn:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
  .auth-back {
    text-align: center; margin-top: 24px; font-size: 14px;
    color: var(--auth-subtitle, #9ca3af);
  }
  .auth-back a {
    color: var(--auth-link, var(--auth-primary, #6366f1));
    font-weight: 600; text-decoration: none;
  }
  .auth-back a:hover { text-decoration: underline; }
  .auth-step-badge {
    display: inline-flex; align-items: center; gap: 6px;
    background: rgba(99,102,241,0.15); border: 1px solid rgba(99,102,241,0.3);
    color: var(--auth-primary, #6366f1); font-size: 12px; font-weight: 600;
    padding: 4px 12px; border-radius: 999px; margin-bottom: 16px;
  }
`;

const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

const fetchPublic = (key) => {
  const base = getBackendUrl();
  // Cada consulta desiste em 4 s: uma API lenta nao pode segurar a tela.
  const ctrl = typeof AbortController !== "undefined" ? new AbortController() : null;
  const t = ctrl ? setTimeout(() => ctrl.abort(), 4000) : null;
  return fetch(`${base}/public-settings/${key}?token=wtV`, ctrl ? { signal: ctrl.signal } : undefined)
    .then(r => r.json())
    .catch(() => null)
    .finally(() => t && clearTimeout(t));
};

const EyeIcon = ({ open }) => open
  ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
  : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>;

const ForgetPassword = () => {
  const history = useHistory();

  const [step, setStep] = useState("email"); // "email" | "reset"
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  /* slideshow */
  const [bgImages, setBgImages] = useState([wallfundo]);
  const [bgIndex, setBgIndex] = useState(0);
  const [slideContent, setSlideContent] = useState([{}, {}, {}]);

  /* branding */
  const [appName, setAppName] = useState("");
  const [siteLogo, setSiteLogo] = useState("");
  const [primaryColor, setPrimaryColor] = useState("#6366f1");
  const [loginRightBg, setLoginRightBg] = useState("");
  const [loginPageBg, setLoginPageBg] = useState("");
  const [loginBtnTextColor, setLoginBtnTextColor] = useState("");
  const [loginInputBg, setLoginInputBg] = useState("");
  const [loginInputBorder, setLoginInputBorder] = useState("");
  const [loginInputText, setLoginInputText] = useState("");
  const [loginLabelColor, setLoginLabelColor] = useState("");
  const [loginTitleColor, setLoginTitleColor] = useState("");
  const [loginSubtitleColor, setLoginSubtitleColor] = useState("");
  const [loginLinkColor, setLoginLinkColor] = useState("");
  const [loginAppNameColor, setLoginAppNameColor] = useState("");
  const [settingsReady, setSettingsReady] = useState(false);

  const params = qs.parse(window.location.search);
  const companyId = params.companyId || null;

  useEffect(() => {
    const base = getBackendUrl();
    Promise.all([
      fetch(`${base}/public-settings/termsImage?token=wtV`).then(r => r.json()).catch(() => null),
      fetch(`${base}/public-settings/termsImage2?token=wtV`).then(r => r.json()).catch(() => null),
      fetch(`${base}/public-settings/termsImage3?token=wtV`).then(r => r.json()).catch(() => null),
    ]).then(([img1, img2, img3]) => {
      const imgs = [img1, img2, img3].filter(Boolean).map(v => `${base}/public/${v}`);
      if (imgs.length > 0) setBgImages(imgs);
    });

    // A tela so fica visivel quando as configuracoes chegam. Se a API estiver
    // lenta, isso deixava o login TRANSPARENTE por quase um minuto (24/09/2026:
    // parecia tela branca para todos os clientes). Depois de 2,5 s mostra do
    // jeito que estiver; o que chegar depois ainda aplica cores e imagens.
    const __mostrarMesmoAssim = setTimeout(() => setSettingsReady(true), 2500);
    Promise.all([
      fetchPublic("loginSlide1Tag"), fetchPublic("loginSlide1Title"), fetchPublic("loginSlide1Desc"),
      fetchPublic("loginSlide2Tag"), fetchPublic("loginSlide2Title"), fetchPublic("loginSlide2Desc"),
      fetchPublic("loginSlide3Tag"), fetchPublic("loginSlide3Title"), fetchPublic("loginSlide3Desc"),
      fetchPublic("loginBtnBg"), fetchPublic("primaryColorLight"),
      fetchPublic("loginRightBg"), fetchPublic("loginPageBg"),
      fetchPublic("loginBtnTextColor"), fetchPublic("loginInputBg"),
      fetchPublic("loginInputBorder"), fetchPublic("loginInputText"),
      fetchPublic("loginLabelColor"), fetchPublic("loginTitleColor"),
      fetchPublic("loginSubtitleColor"), fetchPublic("loginLinkColor"),
      fetchPublic("loginAppNameColor"), fetchPublic("appName"), fetchPublic("appLogoSite"),
    ]).then(([
      s1t, s1ti, s1d, s2t, s2ti, s2d, s3t, s3ti, s3d,
      btnBg, pColor, rightBg, pageBg,
      btnText, inputBg, inputBorder, inputText,
      labelColor, titleColor, subtitleColor, linkColor, appNameColor, name, logoSite,
    ]) => {
      setSlideContent([
        { tag: s1t || "", title: s1ti || "", desc: s1d || "" },
        { tag: s2t || "", title: s2ti || "", desc: s2d || "" },
        { tag: s3t || "", title: s3ti || "", desc: s3d || "" },
      ]);
      if (btnBg) setPrimaryColor(btnBg);
      else if (pColor) setPrimaryColor(pColor);
      if (rightBg) setLoginRightBg(rightBg);
      if (pageBg) setLoginPageBg(pageBg);
      if (btnText) setLoginBtnTextColor(btnText);
      if (inputBg) setLoginInputBg(inputBg);
      if (inputBorder) setLoginInputBorder(inputBorder);
      if (inputText) setLoginInputText(inputText);
      if (labelColor) setLoginLabelColor(labelColor);
      if (titleColor) setLoginTitleColor(titleColor);
      if (subtitleColor) setLoginSubtitleColor(subtitleColor);
      if (linkColor) setLoginLinkColor(linkColor);
      if (appNameColor) setLoginAppNameColor(appNameColor);
      if (logoSite) setSiteLogo(`${base}/public/${logoSite}`);
      if (name) setAppName(name);
      clearTimeout(__mostrarMesmoAssim);
      setSettingsReady(true);
    });
  }, []);

  useEffect(() => {
    if (bgImages.length <= 1) return;
    const id = setInterval(() => setBgIndex(i => (i + 1) % bgImages.length), 7000);
    return () => clearInterval(id);
  }, [bgImages.length]);

  const primary = primaryColor || "#6366f1";

  const handleSendEmail = async (email) => {
    try {
      // Dados no corpo, nunca no endereco: no endereco a senha era cortada em
      // "#" ou "?" e ficava gravada no log do servidor (30/09/2026).
      const response = await api.post(
        `${process.env.REACT_APP_BACKEND_URL}/forgetpassword`,
        { email: String(email || "").trim() }
      );
      if (response.data.status === 404) {
        toast.error("E-mail não encontrado");
      } else {
        toast.success("E-mail enviado com sucesso!");
        setStep("reset");
      }
    } catch (err) {
      toastError(err);
    }
  };

  const handleResetPassword = async (values) => {
    try {
      await api.post(`${process.env.REACT_APP_BACKEND_URL}/resetpasswords`, {
        email: String(values.email || "").trim(),
        token: String(values.token || "").trim(),
        password: values.newPassword
      });
      toast.success("Senha redefinida com sucesso.");
      history.push("/login");
    } catch (err) {
      toastError(err);
    }
  };

  const EmailSchema = Yup.object().shape({
    email: Yup.string().email("E-mail inválido").required("Obrigatório"),
  });

  const ResetSchema = Yup.object().shape({
    email: Yup.string().email("E-mail inválido").required("Obrigatório"),
    token: Yup.string().required("Obrigatório"),
    newPassword: Yup.string()
      .required("Obrigatório")
      .matches(passwordRegex, "Mínimo 8 caracteres, com maiúscula, minúscula e número."),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "As senhas não correspondem")
      .required("Obrigatório"),
  });

  const slide = slideContent[bgIndex] || {};

  return (
    <>
      <Helmet><title>Recuperar Senha</title></Helmet>
      <style>{AUTH_CSS}</style>

      <div
        className="auth-page"
        style={{
          "--auth-page-bg":     loginPageBg  || undefined,
          "--auth-right-bg":    loginRightBg || undefined,
          "--auth-primary":     primary,
          "--auth-btn-text":    loginBtnTextColor   || undefined,
          "--auth-input-bg":    loginInputBg        || undefined,
          "--auth-input-border":loginInputBorder    || undefined,
          "--auth-input-text":  loginInputText      || undefined,
          "--auth-label":       loginLabelColor     || undefined,
          "--auth-title":       loginTitleColor     || undefined,
          "--auth-subtitle":    loginSubtitleColor  || undefined,
          "--auth-link":        loginLinkColor      || undefined,
          "--auth-name":        loginAppNameColor   || undefined,
          opacity: settingsReady ? 1 : 0,
          transition: "opacity 0.25s ease",
        }}
      >
        <div className="auth-root">
          {/* ── painel esquerdo ── */}
          <div className="auth-left">
            {bgImages.map((src, i) => (
              <img key={src} src={src} alt="" className="auth-left__img" style={{ opacity: i === bgIndex ? 1 : 0 }} />
            ))}
            <div className="auth-left__overlay" />
            <div className="auth-left__content">
              {slide.tag && <span className="auth-left__badge">{slide.tag}</span>}
              <div className="auth-left__spacer" />
              {slide.title && <h2 className="auth-left__title">{slide.title}</h2>}
              {slide.desc  && <p  className="auth-left__desc">{slide.desc}</p>}
              {bgImages.length > 1 && (
                <div className="auth-left__dots">
                  {bgImages.map((_, i) => (
                    <button
                      key={i}
                      className={`auth-left__dot${i === bgIndex ? " auth-left__dot--active" : ""}`}
                      onClick={() => setBgIndex(i)}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* ── painel direito ── */}
          <div className="auth-right">
            {siteLogo ? (
              <img
                src={siteLogo}
                alt={appName || "Logo"}
                style={{ height: 62, maxWidth: 280, objectFit: "contain", marginBottom: 20 }}
              />
            ) : (
              appName && <div className="auth-name">{appName}</div>
            )}

            <div className="auth-form-box">
              <div className="auth-step-badge">
                {step === "email" ? "Passo 1 de 2" : "Passo 2 de 2"}
              </div>

              <h1 className="auth-heading">
                {step === "email" ? "Recuperar senha" : "Redefinir senha"}
              </h1>
              <p className="auth-subtext">
                {step === "email"
                  ? "Digite seu e-mail para receber o código de recuperação."
                  : "Digite o código recebido e escolha sua nova senha."
                }
              </p>

              {step === "email" ? (
                <Formik
                  initialValues={{ email: "" }}
                  validationSchema={EmailSchema}
                  onSubmit={async (values, actions) => {
                    await handleSendEmail(values.email);
                    actions.setSubmitting(false);
                  }}
                >
                  {({ values, handleChange, handleBlur, errors, touched, isSubmitting }) => (
                    <Form className="auth-form">
                      <div className="auth-field-wrap">
                        <label className="auth-label" htmlFor="fp-email">Seu E-mail</label>
                        <input
                          id="fp-email"
                          name="email"
                          type="email"
                          autoComplete="email"
                          className="auth-field"
                          placeholder="seuemail@exemplo.com"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {touched.email && errors.email && (
                          <div className="auth-field-error">{errors.email}</div>
                        )}
                      </div>

                      <button type="submit" className="auth-btn" disabled={isSubmitting}>
                        {isSubmitting ? "Enviando…" : "Enviar código"}
                      </button>
                    </Form>
                  )}
                </Formik>
              ) : (
                <Formik
                  initialValues={{ email: "", token: "", newPassword: "", confirmPassword: "" }}
                  validationSchema={ResetSchema}
                  onSubmit={async (values, actions) => {
                    await handleResetPassword(values);
                    actions.setSubmitting(false);
                  }}
                >
                  {({ values, handleChange, handleBlur, errors, touched, isSubmitting }) => (
                    <Form className="auth-form">
                      <div className="auth-field-wrap">
                        <label className="auth-label" htmlFor="rp-email">Seu E-mail</label>
                        <input
                          id="rp-email"
                          name="email"
                          type="email"
                          autoComplete="email"
                          className="auth-field"
                          placeholder="seuemail@exemplo.com"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {touched.email && errors.email && (
                          <div className="auth-field-error">{errors.email}</div>
                        )}
                      </div>

                      <div className="auth-field-wrap">
                        <label className="auth-label" htmlFor="rp-token">Código de verificação</label>
                        <input
                          id="rp-token"
                          name="token"
                          type="text"
                          autoComplete="off"
                          className="auth-field"
                          placeholder="Cole o código recebido por e-mail"
                          value={values.token}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {touched.token && errors.token && (
                          <div className="auth-field-error">{errors.token}</div>
                        )}
                      </div>

                      <div className="auth-field-wrap">
                        <label className="auth-label" htmlFor="rp-pwd">Nova senha</label>
                        <input
                          id="rp-pwd"
                          name="newPassword"
                          type={showPassword ? "text" : "password"}
                          autoComplete="new-password"
                          className="auth-field auth-field--pw"
                          placeholder="Mínimo 8 caracteres"
                          value={values.newPassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <button type="button" className="auth-pw-toggle" onClick={() => setShowPassword(v => !v)}>
                          <EyeIcon open={showPassword} />
                        </button>
                        {touched.newPassword && errors.newPassword && (
                          <div className="auth-field-error">{errors.newPassword}</div>
                        )}
                      </div>

                      <div className="auth-field-wrap">
                        <label className="auth-label" htmlFor="rp-confirm">Confirmar senha</label>
                        <input
                          id="rp-confirm"
                          name="confirmPassword"
                          type={showConfirmPassword ? "text" : "password"}
                          autoComplete="new-password"
                          className="auth-field auth-field--pw"
                          placeholder="Repita a nova senha"
                          value={values.confirmPassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <button type="button" className="auth-pw-toggle" onClick={() => setShowConfirmPassword(v => !v)}>
                          <EyeIcon open={showConfirmPassword} />
                        </button>
                        {touched.confirmPassword && errors.confirmPassword && (
                          <div className="auth-field-error">{errors.confirmPassword}</div>
                        )}
                      </div>

                      <button type="submit" className="auth-btn" disabled={isSubmitting}>
                        {isSubmitting ? "Salvando…" : "Redefinir senha"}
                      </button>
                    </Form>
                  )}
                </Formik>
              )}

              <div className="auth-back">
                Lembrou a senha?{" "}
                <RouterLink to="/login">Voltar para o Login</RouterLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
